import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const EquipItem = () => {
   const [showModal, setShowModal] = useState(false)
   const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
   const handleOpenModal = (contentType, category, index, maxIndex) => {
       setModalContent({ contentType, category, index, maxIndex })
       setShowModal(true)
   }
  const handleCloseModal = () => {
      setModalContent({ contentType: '', category: '', index: 0 })
      setShowModal(false)
  }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-equip-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Dans ce jeu, il est possible de <span className='text-pborange'>s'équiper</span> avec tous les
                        objets : non seulement les épées et les bâtons, mais aussi{' '}
                        <span className='text-pborange'>
                            les roches et les fleurs présentes sur les cartes, voire les ennemis eux-mêmes
                        </span>{' '}
                        !
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 1)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-1-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Vous pouvez vous équiper des éléments de la carte, comme les personnages et les objets, en
                            les « portant ».
                        </p>
                    </div>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 2)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-2-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Vous pouvez également voler les armes des ennemis et vous en équiper ! N'oubliez toutefois
                            pas de vérifier la probabilité de réussite du vol !
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Les objets dont vous pouvez vous équiper possèdent à la fois des{' '}
                        <span className='text-pborange'>Capacités</span> et des{' '}
                        <span className='text-pborange'>Compétences</span>. Les personnages qui s'équipent de ces objets
                        peuvent utiliser leurs Capacités et bénéficier des effets de leurs Compétences.
                    </p>{' '}
                    <div className='mt-8'>
                        <div className='flex flex-col md:flex-row gap-4 mt-8'>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 3)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-3-s.webp`}
                                />
                            </div>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 4)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-4-s.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            On peut considérer les Capacités comme des « techniques », et les Compétences comme des
                            capacités « passives ».
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Dans Phantom Brave: The Lost Hero, vous pouvez également vous équiper de divers objets présents
                        sur le terrain. Si vous n'êtes équipé d'aucun objet, essayez de vous équiper de choses
                        insolites, comme de l'herbe, des arbres ou des roches ! Les arbres, les roches, etc. ont
                        également des Capacités et des Compétences. En vous en équipant, vous aurez accès à diverses
                        Compétences et à des effets qui améliorent votre état.
                    </p>{' '}
                    <div className='mt-8'>
                        <div className='flex flex-col md:flex-row gap-4 mt-8'>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 5)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-5-s.webp`}
                                />
                            </div>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 6)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-6-s.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Si vous vous équipez du palmier qui se trouvait sur la carte, vous pourrez utiliser{' '}
                            <span className='whitespace-nowrap'>« Ruée en rafale »</span> et « Petits soins » !
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        De plus, si vous <span className='text-pborange'>emplissez certaines conditionsr</span>, vous
                        pourrez apprendre ces Capacités et Compétences de façon permanente. L'apprentissage de Capacités
                        et Compétences puissantes ne manquera pas de vous donner un avantage dans les combats à venir !
                    </p>{' '}
                    <div className='md:w-4/5 w-full mt-8 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 7)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-7-s.webp`}
                        />{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        Lorsqu'un personnage subit des dégâts, une partie de ceux-ci peuvent{' '}
                        <span className='text-pborange'>être absorbés</span> par certains objets équipés ou par un allié
                        servant de bouclier humain ! Cependant, si les PV de cet allié ou ceux de l'objet équipé tombent
                        à 0, <span className='text-pborange'>l'objet devient inutilisable et l'allié est mis KO</span>.
                        De plus, dans cet état, si l'allié subit une autre attaque, il entre en état de Désâmisation et
                        il
                        <span className='text-pborange'> disparaît de la carte</span>.
                    </p>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={3}
                />
            </div>
        </>
    )
}
